export default __webpack_public_path__ + "static/media/SDCAR.f1dc928a.gif";